<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="500px">
    <v-card class="cardCustom" style="padding: 10px 0 !important;">
      <v-btn
            class="close-button"
            title="Отменить"
            variant="text"
            text
            @click="close"
        >
            <v-icon>ti-close</v-icon>
        </v-btn>

      <v-card-title style="text-align: center; display: block; font-size: 18px; padding-bottom: 0;">
        Назначение интервью
      </v-card-title>

        <v-card-text>
            <div class="container-user-interview">
              <div class="h-v-center">
                <div class="container-img">
                  <div
                    v-if="hasAvatar(userObj)"
                    class="custom-bg-img"
                    :style="avatarStyle(userObj.avatar)"
                  />
                  <img v-else src="@/assets/img/no-foto.png" />
                </div>
              </div>

              <div class="right-block-interview">
                <h4>
                  {{ userObj.name }}
                  {{ userObj.lastName }}
                </h4>
                <p>Кандидат</p>
              </div>
            </div>

            <v-form ref="form">
              <v-row>

                <v-col cols="12" md="12" class="input-text container-field-interview">
                  <label>Название</label>
                  <v-text-field
                    v-model="title"
                    :rules="[v => !!v || 'Обязательно']"
                    required
                  />
                </v-col>

                <v-col cols="12" md="12" class="input-text container-field-interview">
                  <label>Дата</label>
                  <v-text-field
                    type="datetime-local" 
                    v-model="date"
                    :rules="[v => !!v || 'Обязательно']"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="12" class="custom-selected1 container-field-interview">
                    <label>Участники</label>
                    <multiselect 
                        class="custom-ul"
                        v-model="participants" 
                        placeholder="Введите для поиска" 
                        label="title" 
                        track-by="id"
                        :multiple="true"
                        :options="options" 
                        :option-height="90" 
                        :custom-label="customLabel" 
                        :close-on-select="false"
                        :show-labels="false"
                    >
                        <span slot="noResult">Нет результатов</span>
                        <template slot="singleLabel" slot-scope="props">
                            <span style="display:none">{{props.option.id}}</span>
                            <img class="option__image select-img" :src="props.option.img">
                            <span class="option__desc">
                                <span class="option__title">{{ props.option.title }}</span>
                            </span>
                        </template>
                        <template slot="option" style="display:flex" slot-scope="props">
                        
                        <div class="option__desc">
                            <span style="display:none">{{props.option.id}}</span>
                            <img v-if="props.option.img != 'noFoto'" class="option__image select-img" style="margin-right: 10px; border-radius: 30px" :src="props.option.img">
                            <img v-else class="option__image select-img" style="margin-right: 10px; border-radius: 30px" src="@/assets/img/no-foto.png" alt="" />
                            <span class="option__title">{{ props.option.title }}</span>
                        </div>
                        </template>
                    </multiselect>
                </v-col>

                <v-col cols="12" md="12" class="custom-selected1 mt-6 container-field-interview">
                    <label>Тип интервью</label>
                    <multiselect
                      class="custom-ul"
                      v-model="typeInterview"
                      placeholder="Выберите тип интервью"
                      label="title"
                      track-by="title"
                      :options="optionsTypeInterview"
                      :custom-label="customLabelInterview"
                      :option-height="10" 
                      :searchable="false"
                      :allow-empty="false"
                      select-label=""
                      selected-label=""
                      deselect-label=""
                      @input="typeError = false"
                    >
                      <template slot="singleLabel" slot-scope="props">
                        <div style="display:flex; align-items: center;">
                          <span class="option__desc">
                            <span class="option__title">{{ props.option.name }}</span>
                          </span>
                        </div>
                      </template>

                      <template slot="option" slot-scope="props">
                        <div style="display:flex; align-items: center;">
                          <div class="option__desc">
                            <span class="option__title"
                                  style="font-size: 14px; font-family: 'Montserrat', sans-serif;">
                              {{ props.option.name }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="typeError" class="v-messages__message v-messages error--text mt-1">
                      Обязательно
                    </div>
                </v-col>

              </v-row>
            </v-form>
        </v-card-text>

        <div class="text-center" >
          <v-col cols="12" md="12" class="input-text" style="padding: 0 36px;">
            <v-btn 
              v-if="!btnLoader" 
              type="submit" 
              class="btnSave primary-btn" 
              @click="save()"
            >
              Сохранить
            </v-btn>
            <v-btn 
              v-else 
              type="submit" 
              class="btnSave primary-btn"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-btn>
          </v-col>
        </div>

    </v-card>
  </v-dialog>
</template>
<script>
import Multiselect from "vue-multiselect";
import GlobalRequest from "@/plugins/globalRequest";

export default {
  name: "InterviewAssignDialog",
  components: { Multiselect },

  props: {
    value: {
        type: Boolean,
        default: false
    },

    intervieweeId: {
        type: [Number, String],
        required: true
    },

    options: {
        type: Array,
        default: () => []
    },

    initialDate: {
        type: String,
        default: ""
    }
  },

  data() {
    return {
      title: "",
      date: this.getDate(),
      participants: [],
      userObj: {},
      btnLoader: false,
      typeInterview: null,
      typeError: false,
      optionsTypeInterview: []
    };
  },

  mounted() {
    this.date = this.initialDate;

    this.getData();
  },

  methods: {
    async save() {
      const valid = await this.$refs.form.validate();

      if (!this.typeInterview) {
        this.typeError = true;
      } else {
        this.typeError = false;
      }

      if (!valid || !this.typeInterview) return;

      this.btnLoader = true;
      
      const body = {
        title: this.title,
        dateTime: this.date,
        interviewee: this.intervieweeId,
        participants: this.participants.map(p => p.id),
        owner: parseInt(localStorage.getItem("current_user")),
        type: this.typeInterview.title || ""
      };

      const res = await GlobalRequest.request("/interviews/add", "POST", body);

      // Если успех, то переходим в интервью
      if(res.success && res.data && res.data.id) {
        this.$router.push({
          name: "InterviewDetail",
          query: {
            back: this.$route.name,
            id: res.data.id
          }
        });
      }

      this.btnLoader = false;

      this.$emit("saveInterview", res);
    },

    close() {
      this.$emit("input", false);
    },

    customLabel ({ title }) {
      return `${title}`
    },

    getDate() {
      const d = new Date();
      return d.toISOString().slice(0, 16);
    },

    async getData() {
      const res = await GlobalRequest.request(`/user/${this.intervieweeId}`, "GET");
      if(res && res.data) {
        this.userObj = res.data || {};
      }

      // Получить список типов интервью
      const resTypes = await GlobalRequest.request(`/interviews/types`, "GET");
      if(resTypes) {
        this.optionsTypeInterview = resTypes || [];
      }
      
    },

    hasAvatar(user) {
      return user && user.avatar;
    },

    avatarStyle(path) {
      return {
        backgroundImage: 'url("' + path + '")',
        width: "100%",
        height: "100%"
      };
    },

    customLabelInterview(item) {
      if (!item) return "";
      return item.title || "";
    },

  }
};
</script>

<style scoped>
  .container-user-interview {
    padding: 20px 0 14px;
  }
  .container-user-interview h4 {
    padding: 0;
    margin: 0;
    font-weight: 500;
    color: #000;
    font-size: 16px;
  }
  .container-user-interview p {
    padding: 0;
    margin: 0;
    font-size: 14px;
  }
  .right-block-interview {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 3px;
  }
  .btnSave {
    min-width: 111px !important;
  }
</style>